import { render, staticRenderFns } from "./GeoWidget.vue?vue&type=template&id=580ccb06&"
import script from "./GeoWidget.vue?vue&type=script&lang=js&"
export * from "./GeoWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports